<script>
  import VideoFrame from "../../elements/VideoFrame.svelte";
  import type { IUVideo } from "../../../core/types";
  import { detectMobDevice } from "../../../core";

  interface IVideoPanel {
    title: string;
    description: string;
    video: {
      desktop: IUVideo;
      mobile: IUVideo;
    };
  }

  export let data: IVideoPanel;

  let media: IUVideo;

  $: media =
    data.video.mobile && detectMobDevice()
      ? data.video.mobile
      : data.video.desktop;
</script>

<section class="video-panel g-centered">
  {#if media}
    <VideoFrame video={media} />
  {/if}

  <div class="caption">
    {#if data.title}
      <div class="caption__title">
        {@html data.title}
      </div>
    {/if}

    {#if data.description}
      <div class="caption__desc">
        {@html data.description}
      </div>
    {/if}
  </div>
</section>

<style lang="scss">
  .video-panel {
    margin-bottom: 30px;

    @include md {
      padding-bottom: 50px;
    }
  }

  .caption {
    padding: 30px 30px 35px;
    background: $text-reverse-color;

    &__title {
      @include h2;
      margin-bottom: 8px;
    }
  }
</style>
